let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("clPXM")).then(() => parcelRequire('96yzA'));